import { AiFillAppstore } from "react-icons/ai";
import {  FaBrain} from "react-icons/fa";
import { SiProgress} from "react-icons/si";
import { CgWebsite } from "react-icons/cg";
import { MdAnalytics } from "react-icons/md";

// Features Data
export const featuresData = [
  {
    id: 1,
    title: "Project Management",
    des: "Want to gain real-life experience of managing a complete software project cycle.",
  },
  {
    id: 2,
    icon: <AiFillAppstore />,
    title: "App Development",
    des: "Will learn this soon in near future !",
  },
  {
    id: 3,
    icon: <SiProgress />,
    title: "DevOps",
    des: "Learning tools like docker,kubernetes,aws !",
  },
  {
    id: 4,
    icon: <CgWebsite />,
    title: "Web Development",
    des: "Have done backend development in Spring Boot and Django ,frontend in React and used Postgress sql and mysql as database. Have developed various projects and hosted them too, check them on my github.",
  },
  {
    id: 5,
    icon: <MdAnalytics />,
    title: "Competetive Programing and Data Structures and Algorithms",
    des: "Solved 1500+ Programming and Algorithm on various coding platform.",
  },
  {
    id: 6,
    icon: <FaBrain />,
    title: "Machine Learning",
    des: "I Have made projects in machine learning . Have developed some projects, check them on my github.",
  },
];
